/** Cabeçalho de página padrão: kicker mono + título display. */
export default function PageHeader({ kicker, title, children }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginBottom: 'var(--space-6)',
        gap: 'var(--space-4)',
        flexWrap: 'wrap',
      }}
    >
      <div>
        {kicker && (
          <div className="kicker" style={{ marginBottom: 8 }}>
            {kicker}
          </div>
        )}
        <h1 className="display" style={{ fontSize: 34, lineHeight: 1 }}>
          {title}
        </h1>
      </div>
      {children}
    </div>
  );
}
